// © Microsoft Corporation. All rights reserved.

import { comment, thumbs_up, users3 } from "../../../utils/icons";

import React from "react";
import { SocialProps } from "../../../Social.props";
import { String } from "typescript-string-operations";
import { classNames } from "@microsoft/fast-web-utilities";
import { enums } from "../../../utils/enums";
import { hasThemeBase } from "../../../utils/themeHelpers";

export interface ProfileCardUserStatsProps extends SocialProps {
    postsCount: number;
    followersCount: number;
    likesCount: number;
    isSelf?: boolean;
}

export default class ProfileCardUserStats extends React.Component<ProfileCardUserStatsProps, {}> {

    render() {
        const isSuperApp = hasThemeBase(this.props.theme, enums.theme.superappBase);
        return isSuperApp ? this.renderSuperApp() : this.renderDefault();
    }

    renderDefault() {
        const { postsCount, followersCount, likesCount, t, responsiveClass, managedClasses } = this.props;

        return (
            <div className={classNames(
                managedClasses.profileCardUserStatsContainer,
                responsiveClass
            )}>
                <div className="cwt-stat" tabIndex={0} aria-label={postsCount > 1 ? String.Format(t.AriaLabelComments, postsCount) : String.Format(t.AriaLabelComment, postsCount)}>
                    <h6 aria-hidden="true">{t.UserCardPosts}</h6>
                    <span className="cwt-stat-counter" aria-hidden="true">{postsCount || "-"}</span>
                </div>
                <div className="cwt-stat" tabIndex={0} aria-label={followersCount > 1 ? String.Format(t.AriaLabelFollowers, followersCount) : String.Format(t.AriaLabelFollower, followersCount)}>
                    <h6 aria-hidden="true">{t.ProfileFollowersLbl}</h6>
                    <span className="cwt-stat-counter" aria-hidden="true">{followersCount || "-"}</span>
                </div>
                <div className="cwt-stat" tabIndex={0} aria-label={likesCount > 1 ? String.Format(t.AriaLabelReactions, likesCount) : String.Format(t.AriaLabelReaction, likesCount)}>
                    <h6 aria-hidden="true">{t.ProfileReactionsLbl}</h6>
                    <span className="cwt-stat-counter" aria-hidden="true">{likesCount || "-"}</span>
                </div>
            </div>
        );
    }

    renderSuperApp() {
        const { postsCount, followersCount, likesCount, isSelf, responsiveClass, managedClasses, t } = this.props;

        return (
            <div className={classNames(
                managedClasses.profileCardUserStatsContainer,
                responsiveClass,
                managedClasses.profileCardUserStatsSuperAppContainer,
                ["cwt-stats-others", !isSelf]

            )}>
                <div className="cwt-stat" tabIndex={0} aria-label={postsCount > 1 ?  String.Format(t.AriaLabelComments, postsCount) : String.Format(t.AriaLabelComment, postsCount)}>
                    <i className="cwt-icon cwt-disabled-message" aria-hidden="true">
                        { comment }
                    </i>
                    <span className="cwt-stat-counter" aria-hidden="true">{postsCount || "-"}</span>
                </div>
                <div className="cwt-stat" tabIndex={0} aria-label={followersCount > 1 ?  String.Format(t.AriaLabelFollowers, followersCount) : String.Format(t.AriaLabelFollower, followersCount)}>
                    <i className="cwt-icon cwt-disabled-message" aria-hidden="true">
                        { users3 }
                    </i>
                    <span className="cwt-stat-counter" aria-hidden="true">{followersCount || "-"}</span>
                </div>
                <div className="cwt-stat" tabIndex={0} aria-label={likesCount > 1 ? String.Format(t.AriaLabelReactions, likesCount) : String.Format(t.AriaLabelReaction, likesCount)}>
                    <i className="cwt-icon cwt-disabled-message" aria-hidden="true">
                        { thumbs_up }
                    </i>
                    <span className="cwt-stat-counter" aria-hidden="true">{likesCount || "-"}</span>
                </div>
            </div>
        );
    }

}
